import type { Location } from 'modules/core/lib/navigation/types'

export const navigation = {
  path: 'time-off',
  children: {
    leavesNew: {
      path: 'leaves/new',
    },
    leavesEditLeaveId: {
      path: 'leaves/edit/:leave_id',
    },
    leavesRejectLeaveId: {
      path: 'leaves/reject/:leave_id',
    },
    leaveUpdatesLeaveIdEditMedicalLeave: {
      path: 'leave_updates/:leave_id/editMedicalLeave',
    },
    leaveUpdatesLeaveIdNew: {
      path: 'leave_updates/:leave_id/new',
    },
    leaveUpdatesLeaveIdEditLeaveUpdateId: {
      path: 'leave_updates/:leave_id/edit/:leave_update_id',
    },
  },
} as const satisfies Location
